import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

import { ToBePaid } from '../../models/to-be-paid';

@Injectable()
export class ToBePaidService {
  private to_be_paids_url = 'to_be_paids';

  constructor(private httpClient: HttpClientService) {}

  createCheck(params: any): Promise<any> {
    return this.httpClient.post(`${this.to_be_paids_url}/create_check.json`, params);
  }

  getBankAccountDetails(chart_of_account_ids: Array<number>, bank_account_id?: number): Promise<any> {
    return this.httpClient.get(`${this.to_be_paids_url}.json`, {
      get_bank_account_details: true,
      chart_of_account_ids: chart_of_account_ids.join(','),
      bank_account_id: bank_account_id,
    });
  }

  getEditToBePaid(to_be_paid_id: any): Promise<any> {
    return this.httpClient.get(`${this.to_be_paids_url}/${to_be_paid_id}/edit.json`);
  }

  getFormOptions(): Promise<any> {
    return this.httpClient.get(`${this.to_be_paids_url}.json`, { get_form_options: true });
  }

  getMatterToBePaids(matter_id: any): Promise<any> {
    return this.httpClient.get(`${this.to_be_paids_url}.json`, {
      get_matter_to_be_paids: true,
      matter_id: matter_id,
    });
  }

  getToBePaid(id: number): Promise<any> {
    return this.httpClient.get(`${this.to_be_paids_url}/${id}.json`);
  }

  getToBePaids(params: any): Promise<any> {
    params.get_search = true;
    return this.httpClient.get(`${this.to_be_paids_url}.json`, params);
  }

  getSearchOptions(): Promise<any> {
    return this.httpClient.get(`${this.to_be_paids_url}.json`, { get_search_options: true });
  }

  newScanToBePaid(scan_id: number, auto_redirect_rule_id: number, full_amount: number = 0): Promise<{ success: string; to_be_paid: ToBePaid; text: string; matter: any }> {
    return this.httpClient.get(`${this.to_be_paids_url}/new.json`, { to_be_paid_from_scan: true, scan_id: scan_id, full_amount: full_amount, auto_redirect_rule_id: auto_redirect_rule_id }).then((response) => response as { success: string; to_be_paid: ToBePaid; text: string; matter: any });
  }

  saveToBePaid(toBePaid: ToBePaid): Promise<any> {
    if (toBePaid.id) return this.httpClient.put(`${this.to_be_paids_url}/${toBePaid.id}.json`, { to_be_paid: toBePaid });
    else return this.httpClient.post(`${this.to_be_paids_url}.json`, { to_be_paid: toBePaid });
  }
}
